import { EventForGetEventsResponse } from "App/api/endpoints/events/responses";
import { EventCategory } from "App/common/enums";
import { key_Drift, key_JamboreesAndSpots, key_Others, key_Races, key_Rallies, key_RcModels } from "App/common/utils/eventCategoryGrouping.utils";
import moment, { Moment } from "moment";
import countries from 'i18n-iso-countries';
import i18n from "i18n";

const rallyColor = '#248302';
const raceColor = '#AB1313';
const otherColor = '#2652ca';
const jamboreeColor = '#ed5801';
const driftColor = '#ca009e';
const rcModelColor = 'black';

export const EventUtils = {
    buildDateString: (dateStart: Moment, dateEnd: Moment): string => {
        dateStart = moment(dateStart.toString());
        dateEnd = moment(dateEnd.toString());

        const endDateString = dateEnd.format("DD.MM.YYYY");

        if(dateStart.year() === dateEnd.year()) {
            if(dateStart.month() === dateEnd.month()) {
                if(dateStart.date() === dateEnd.date()) {
                    return endDateString;
                }
                return `${dateStart.format("DD")}-${endDateString}`;
            }
            return `${dateStart.format("DD.MM")}-${endDateString}`;
        }
        return `${dateStart.format("DD.MM.YYYY")}-${endDateString}`;
    },

    buildLocationString: (event: EventForGetEventsResponse): string => {
        if (!event.state?.length)
            return countries.getName(event.country, i18n.language);

        if (event.locationName?.length)
            return `${event.state}, ${event.locationName}`;
        
        let locationString = event.state;
        if (event.city?.length)
            locationString = locationString + `, ${event.city}`;
        if (event.street?.length)
            locationString = locationString += `, ${event.street}`;

        return locationString;
    },

    categoryGroupColor: (key: string | number): string => {
        if(key === key_Rallies) return rallyColor;
        if(key === key_Races) return raceColor;
        if(key === key_Others) return otherColor;
        if(key === key_JamboreesAndSpots) return jamboreeColor;
        if(key === key_Drift) return driftColor;
        if(key === key_RcModels) return rcModelColor;

        return 'white';
    },

    categoryColor: (category: EventCategory): string => {
        let color = 'blue';

        category = EventCategory[category] as any;

        // Rajdy
        if(category === EventCategory.Rally) color = rallyColor;
        if(category === EventCategory.Kjs) color = rallyColor;
        if(category === EventCategory.Rallysprint) color = rallyColor;
        if(category === EventCategory.SuperStage) color = rallyColor;
        if(category === EventCategory.SuperSprint) color = rallyColor;
        if(category === EventCategory.Offroad) color = rallyColor;
        if(category === EventCategory.RSMP) color = rallyColor;
        if(category === EventCategory.HRSMP) color = rallyColor;
        if(category === EventCategory.RMPZ) color = rallyColor;
        if(category === EventCategory.RSMSL) color = rallyColor;
        if(category === EventCategory.RSMDSL) color = rallyColor;
        if(category === EventCategory.RO) color = rallyColor;
        if(category === EventCategory.SKJS) color = rallyColor;
        if(category === EventCategory.Wrc) color = rallyColor;

        // Wyścigi
        if(category === EventCategory.RaceFlat) color = raceColor;
        if(category === EventCategory.RaceMountain) color = raceColor;
        if(category === EventCategory.Rallycross) color = raceColor;
        if(category === EventCategory.WreckRace) color = raceColor;
        if(category === EventCategory.TimeAttack) color = raceColor;
        if(category === EventCategory.TrackDay) color = raceColor;
        if(category === EventCategory.DragRace) color = raceColor;
        if(category === EventCategory.Autocross) color = raceColor;
        if(category === EventCategory.Sprint) color = raceColor;

        // Drift
        if(category === EventCategory.DriftCompPro) color = driftColor;
        if(category === EventCategory.DriftCompAm) color = driftColor;
        if(category === EventCategory.DriftTraining) color = driftColor;
        if(category === EventCategory.DriftOther) color = driftColor;

        // Modele RC
        if(category === EventCategory.RcDrift) color = rcModelColor;
        if(category === EventCategory.RcTrial) color = rcModelColor;
        if(category === EventCategory.RcOffroad) color = rcModelColor;
        if(category === EventCategory.RcRally) color = rcModelColor;
        if(category === EventCategory.RcIndoorRace) color = rcModelColor;
        if(category === EventCategory.RcShow) color = rcModelColor;

        // Inne
        if(category === EventCategory.Fair) color = otherColor;
        if(category === EventCategory.Training) color = otherColor;
        if(category === EventCategory.Schooling) color = otherColor;
        if(category === EventCategory.FreeRide) color = otherColor;
        if(category === EventCategory.Charity) color = otherColor;
        if(category === EventCategory.Integration) color = otherColor;
        if(category === EventCategory.Exhibition) color = otherColor;

        // Zloty i spoty
        if(category === EventCategory.Jamboree) color = jamboreeColor;
        if(category === EventCategory.Meetup) color = jamboreeColor;
        if(category === EventCategory.Classic) color = jamboreeColor;
        if(category === EventCategory.Oldtimer) color = jamboreeColor;
        if(category === EventCategory.American) color = jamboreeColor;
        if(category === EventCategory.Stance) color = jamboreeColor;
        if(category === EventCategory.Tuning) color = jamboreeColor;
        if(category === EventCategory.Bmw) color = jamboreeColor;
        if(category === EventCategory.Vw) color = jamboreeColor;
        if(category === EventCategory.Jdm) color = jamboreeColor;

        return color;
    }
}